/**
 * Mismas proporciones en reposo (teclado + historial) y en vista de llamada (avatar + CRM)
 * para que el FAB no “salte” en ancho ni en altura de fila.
 */
export const FAB_DIALER_LEFT_FLEX = '0 0 46%';
export const FAB_DIALER_LEFT_MAX_WIDTH = '50%';
export const FAB_DIALER_RIGHT_FLEX = '1 1 54%';
